<div class="chat-start-timestamp">
  <span data-automation-id="conversation-started-timestamp">{{ conversationStarted$ | async }}</span>
  <app-copy-text-to-clipboard
    [linkText]="'gcChatMessageList.copyConversationId' | translate"
    [textToCopy]="conversationId$ | async"
  >
  </app-copy-text-to-clipboard>
</div>

<div class="list-items">
  <app-genesys-chat-message-list-item
    *ngFor="let message of messages$ | async as messages; index as idx; trackBy: messageTrackByFn"
    [contact]="contact"
    [message]="message"
    [isFirstSegmentMessage]="isFirstSegmentMessage(messages, idx)"
    [isLastSegmentMessage]="isLastSegmentMessage(messages, idx)"
    [attachments]="getAttachments$(message) | async"
    (imageLoad)="imageLoad.emit()"
  ></app-genesys-chat-message-list-item>
  <app-genesys-chat-message-typing-indicator *ngIf="isCustomerTyping$ | async">
  </app-genesys-chat-message-typing-indicator>
</div>
<div class="chat-end-text" *ngIf="isMessagingPeriodEnded">
  {{ messageType$ | async | appChatPeriodEndedText | translate }}
</div>
